import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { LanguageProvider } from './utilities/LanguageContext' // Importa el proveedor del contexto
import { FloatMessageProvider } from './components/Providers/FloatMessage'
//import { GoogleOAuthProvider } from '@react-oauth/google'
//import { StudentSocketProvider } from  './components/Providers/StudentSocketProvider'


const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(<App />);

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <FloatMessageProvider>
        {/* <StudentSocketProvider> */}
          {/* <GoogleOAuthProvider clientId='559876239718-rccdkeaqoqopjq75mu7dm4rgauc3pvnn.apps.googleusercontent.com'> */}
            <App />
          {/* </GoogleOAuthProvider> */}
        {/* </StudentSocketProvider> */}
      </FloatMessageProvider>
    </LanguageProvider>
  </React.StrictMode>
);